import Immutable from 'immutable';
import React from 'react';
import GalleryActionCreators from '../../actions/GalleryActionCreators.js';
import GalleryStore from '../../stores/GalleryStore';
import GalleryBoxToolbar from './GalleryBoxToolbar.react';
import GalleryBoxCompliment from './GalleryBoxCompliment.react';

// state vērtības no store
function getStateFromStores() {
  return {
    image: GalleryStore.getCurrent(), // bildes objekts
    complimentSending: GalleryStore.getComplimentSending(), // vai tiek pievienots kompliments
  };
}

class GalleryBoxPanel extends React.PureComponent {
	static displayName = 'GalleryBoxPanel';

	static defaultProps = {
	  hideToolbar: false,
	};

	constructor(props) {
	  super(props);
	  const data = getStateFromStores();

	  // rādīt / nerādīt komplimentu ievadi]
	  data.complimentBox = false;

	  this.state = {
	    data: Immutable.Map(data),
	  };
	}

	setImmState = fn => this.setState((prevState) => {
	  const data = prevState.data;
	  return {
	    data: fn(data),
	  };
	});

	componentDidMount() {
	  GalleryStore.addChangeListener(this._onChange);
	}

	componentWillUnmount() {
	  GalleryStore.removeChangeListener(this._onChange);
	}

	render() {
	  const data = this.state.data;
	  // bilde nav ielādēta
	  if (!data.get('image') || data.get('image').get('load_status') != 'ok') {
	    return null;
	  }

	  const self = this;

	  const Toolbar = function () {
	    // rādīt tikai tad, ja nav aktīvs komplimentu ievades bloks
	    if (data.get('complimentBox')) {
	      return null;
	    }

	    return (
  <div>
    <GalleryBoxToolbar
      showReportButton={self.props.showReportButton}
      showLikeButton={self.props.showLikeButton}
      showComplimentButton={self.props.showComplimentButton}
      onClickCompliment={self._onClickCompliment}
    />
  </div>
	    );
	  };

	  const ComplimentBox = function () {
	    // rādīt tikai tad, ja aktīvs komplimentu ievades bloks
	    if (!data.get('complimentBox')) {
	      return null;
	    }

	    return (
  <div>
    <GalleryBoxCompliment
      complimentSending={data.get('complimentSending')}
      onClose={self._onCloseCompliment}
      onMessageSubmit={self._onSubmitCompliment}
    />
  </div>
	    );
	  };

	  return (
  <div className="galleryBoxPanel">
    {Toolbar()}
    {ComplimentBox()}
  </div>
	  );
	}

	/**
	* Event handler for 'change' events coming from the stores
	*/
	_onChange = () => {
	  const data = this.state.data;
	  const stateData = getStateFromStores();

	  // ja ir aktīvs komplimentu ievades bloks un ir pievienots kompliments,
	  // tad komplimentu bloku vācam nost
	  // , kā arī ja mainās bilde
	  if (
	    data.get('complimentBox')
				&&
				(
				  stateData.image.get('is_compliment')
					||
					data.get('image').get('index') != stateData.image.get('index')
				)
	  ) {
	    stateData.complimentBox = false;
	  }

	  // pārveido par immutable MAP, lai būtu korekts merge
	  const stateDataImm = Immutable.Map(stateData);

	  this.setImmState(data => data.merge(stateDataImm));
	};

	/**
	* Event handler for 'onClick' - Compliment button
	*/
	_onClickCompliment = (e) => {
	  e.preventDefault();
	  this.setImmState(data => data.update('complimentBox', item => true));
	};

	/**
	* Event handler - Compliment submit
	*/
	_onSubmitCompliment = (message) => {
	  const data = this.state.data;
	  GalleryActionCreators.addCompliment(data.get('image'), message);
	};

	/**
	* Event handler for 'onClick' - Compliment close button
	*/
	_onCloseCompliment = (e) => {
	  e.preventDefault();
	  this.setImmState(data => data.update('complimentBox', item => false));
	};

	/* shouldComponentUpdate(nextProps, nextState) {
		 return React.addons.shallowCompare(this, nextProps, nextState);
		 } */
}

module.exports = GalleryBoxPanel;
